export default __webpack_public_path__ + "static/media/tablet-survey-report.90b2ab70.png";